import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";

export const MobileNavMenu = ({ open, onClose, navLinks, user, onSignIn, onPreRegister }) => (
  <AnimatePresence>
    {open && (
      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={{ height: "auto", opacity: 1 }}
        exit={{ height: 0, opacity: 0 }}
        transition={{ duration: 0.3 }}
        className="lg:hidden bg-white border-t border-rr-line overflow-hidden"
        data-testid="mobile-menu"
      >
        <div className="flex flex-col px-6 py-6 gap-5">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={onClose}
              data-testid={`mobile-nav-link-${link.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="text-base font-semibold text-rr-navy"
            >
              {link.label}
            </a>
          ))}
          {user ? (
            <Link to="/account" onClick={onClose} data-testid="mobile-account-link" className="text-base font-bold text-rr-navy text-left">
              My Account
            </Link>
          ) : (
            <button onClick={() => { onClose(); onSignIn(); }} data-testid="mobile-signin-button" className="text-base font-bold text-rr-navy text-left">
              Sign In
            </button>
          )}
          {user && (
            <Link to="/driver-portal" onClick={onClose} data-testid="mobile-driver-portal-link" className="text-base font-bold text-rr-navy text-left">
              Driver Portal
            </Link>
          )}
          <button
            onClick={() => { onClose(); onPreRegister(); }}
            data-testid="mobile-join-cta"
            className="text-base font-bold bg-rr-orange text-white px-5 py-3 rounded-full text-center"
          >
            Pre-Register
          </button>
        </div>
      </motion.div>
    )}
  </AnimatePresence>
);
